import {
	HEADER,
	TOKENNAME
} from '../config/app';

import axios from 'axios'
import store from '../store'
import router from '../router';

const api =  axios.create({
	baseURL: '/api',
	timeout: 10000
})

axios.defaults.withCredentials = true; // 携带cookie

api.interceptors.request.use(config =>{
	config.headers = HEADER
	const token = store.getters.token
	if(token){
		config.headers[TOKENNAME] = 'Bearer '+token
	}
	return config;
})
api.interceptors.response.use(response => {
	 let obj = {};
   console.log(response.data)
	 if (!!response.data) {
	   if (typeof response.data == 'string') {
	     obj = JSON.parse(response.data);
	   } else {
	     obj = response.data;
	   }
	 }
	 if(obj.status == 200){
		 return obj;
	 }else{
     if(obj.status == 400){
         return obj;
     }else if(obj.status == 410000){
         store.commit('setLogout',1);
         router.replace({ path: '/login' });
         if(!obj.msg){
            obj.msg = '登录失效，请重新登录';
         }
         return Promise.reject(obj);
     }else if(obj.status == 99999){
         store.commit('setLogout',1);
         router.replace({ path: '/login' });
         if(!obj.msg){
            obj.msg = '您的账号在其他地方登录，请检查账户状态';
         }
         return Promise.reject(obj);
     }else if(obj.status == 88888){
         store.commit('setLogout',1);
         router.replace({ path: '/login' });
         if(!obj.msg){
            obj.msg = '您的账户已过期，请联系管理员';
         }
         return Promise.reject(obj);
     }else if(obj.status == 410010){
         store.commit('setLogout',1);
         router.replace({ path: '/close' });
         if(!obj.msg){
            obj.msg = '站点升级中，请稍候访问';
         }
         return Promise.reject(obj);
     }else{
         return obj;
     }
	 }
},error => {
    console.log('完整错误:', error)
    if(error.response){
      console.log('状态码:', error.response.status)
      console.log('后端返回:', error.response.data)
      console.log('响应头:', error.response.headers)
    }
    let obj = {};
	  if(/timeout/.test(error.message)){
		  obj.msg = '连接超时，请刷新';
		  return Promise.reject(obj);
	  }
	  obj.msg = 'ERROR:'+error.message;
	  return Promise.reject(obj);
})

export default api;



// WEBPACK FOOTER //
// ./src/api/index.js